// extracted by mini-css-extract-plugin
module.exports = {"w1xjvhd9":"w1xjvhd9"};